import ReportDesignerPage from "../reporting/reportsV3/designer/components/ReportDesignerPage";

export default ReportDesignerPage;
